import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import "../css/History.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Button
} from "@mui/material";
import getDate from "../../../utils/getDate";
import PopConfirm from "../../../common/PopConfirm";
import NoData from "../components/NoData";
import { updateAlert } from "../redux/actions";

// const greeting = (hour) => {
//   if (hour < 12 && hour > 5) {
//     return "Good morning, ";
//   } else if (hour < 18) {
//     return "Good afternoon, ";
//   } else if (hour < 20) {
//     return "Good evening, ";
//   } else {
//     return "Good night, ";
//   }
// };

const getStatus = (status) => {
  //res.data[i].status === 'Done' ? (<div className='status-done'>Done</div>) : (res.data[i].status === 'Failed' ? <div className='status-failed'>Failed</div> : <div className='status'>{res.data[i].status}</div>)
  for (const s of status) {
    if (s.status === "Done") {
      return [<div className="status-done">Done</div>, s.time, "Done"];
    }
    if (s.status === "Failed") {
      return [<div className="status-failed">Failed</div>, s.time, "Failed"];
    }
    if (s.status === "Processing") {
      return [<div className="status">Processing</div>, s.time, "Processing"];
    }
    if (s.status === "Queuing") {
      return [<div className="status">Queuing</div>, s.time, "Queuing"];
    }
  }

  return [0];
};

function History(props) {

  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState([]);
  const [onDelete, setOnDelete] = useState(false);
  const [historyPage, setHistoryPage] = useState(0);
  const historyRPP = 5

  const handleSort = (tablename, fieldname) => {
    switch (tablename) {
      case "history":
        if (fieldname === "modelName" || fieldname === "status") {
          historyData.sort((a, b) => {
            if (a[fieldname].props.children < b[fieldname].props.children) {
              return -1;
            }
            if (a[fieldname].props.children > b[fieldname].props.children) {
              return 1;
            }
            return 0;
          });
          setHistoryData([...historyData]);
        } else if (fieldname === "date") {
          historyData.sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
          });
          setHistoryData([...historyData]);
        } else {
          historyData.sort((a, b) => {
            if (a[fieldname] < b[fieldname]) {
              return -1;
            }
            if (a[fieldname] > b[fieldname]) {
              return 1;
            }
            return 0;
          });

          setHistoryData([...historyData]);
        }
        break;

      case "comments":
        break;

      default:
        break;
    }
  };

  const historyColumns = [
    {
      title: (
        <Tooltip title="Click to sort" placement="top">
          <div
            className="table-field"
            onClick={() => handleSort("history", "modelName")}
          >
            Model
          </div>
        </Tooltip>
      ),
      dataIndex: "modelName",
      key: "modelName",
    },
    {
      title: (
        <Tooltip title="Click to sort" placement="top">
          <div
            className="table-field"
            onClick={() => handleSort("history", "version")}
          >
            Version
          </div>
        </Tooltip>
      ),
      dataIndex: "version",
      key: "version",
      width: 80,
      align: "center",
    },
    {
      title: (
        <Tooltip title="Click to sort" placement="top">
          <div
            className="table-field"
            onClick={() => handleSort("history", "fileName")}
          >
            File Names
          </div>
        </Tooltip>
      ),
      dataIndex: "fileName",
      key: "fileName",
      align: "center",
    },
    {
      title: (
        <Tooltip title="Click to sort" placement="top">
          <div
            className="table-field"
            onClick={() => handleSort("history", "status")}
          >
            Status
          </div>
        </Tooltip>
      ),
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 50,
    },
    {
      title: (
        <Tooltip title="Click to sort" placement="top">
          <div
            className="table-field"
            onClick={() => handleSort("history", "date")}
          >
            Date
          </div>
        </Tooltip>
      ),
      dataIndex: "date",
      key: "date",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      width: 76,
    },
  ];

  const handleChangeHistoryPage = (e, newPage) => {
    setHistoryPage(newPage);
  };

  const handleHistoryCancel = (e) => { };

  useEffect(() => {
    const handleHistoryConfirm = (id, disabled) => {
      if (!disabled) {
        // delete record
        axios({
          method: "get",
          url: `/api/m2d/results/delete/${id}`,
        }).then((res) => {
          if (res.data && res.data.result === "succeed") {
            setOnDelete(!onDelete);
            props.handleAlert("success", "Successfully deleted!");
          }
        });
      } else {
        props.handleAlert("error", "Unable to delete processing jobs!", 3000);
      }
    };

    const handleShowResult = (id) => {
      navigate(`/m2d/history/results?rid=${id}`);
    };

    if (!props.user.id) {
      navigate("/");
    }
    // setHistoryLoading(true);

    axios({
      method: "post",
      url: `/api/m2d/userinfo/getPendingJobs`,
      data: {
        uid: props.user.id,
      },
    }).then((res) => {
      // set historyData
      const data = [];
      if (res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          let filenames = JSON.parse(res.data[i].fileName).filenames;
          let filename = "";
          if (filenames.length > 1) {
            filename = `${filenames[0]} and ${filenames.length - 1} more files`;
          } else {
            filename = filenames[0];
          }
          data.push({
            key: res.data[i].id,
            modelName: (
              <a href={`/m2d/models/${res.data[i].m2dModel.id}`}>
                {res.data[i].m2dModel.name}
              </a>
            ),
            version: res.data[i].m2dModel.version,
            fileName: filename,
            status: getStatus(res.data[i].m2dJobStatuses)[0],
            date: getDate(getStatus(res.data[i].m2dJobStatuses)[1]),
            action: (
              <div style={{ display: 'flex', flexDirection: 'column', justifyItems: 'center' }}>
                <Button
                  id={res.data[i].id}
                  variant="contained"
                  size="small"
                  style={{ marginBottom: '10px' }}
                  onClick={() => handleShowResult(res.data[i].id)}
                >
                  Result
                </Button>
                {getStatus(res.data[i].m2dJobStatuses)[2] !== "Processing" ? (
                  <PopConfirm
                    message="Are you sure to delete this task?"
                    onConfirm={() =>
                      handleHistoryConfirm(
                        res.data[i].id,
                        res.data[i].status !== "Processing" ? 0 : 1
                      )
                    }
                    onCancel={handleHistoryCancel}
                    okText="yes"
                    cancelText="No"
                  >
                    <Button
                      id={res.data[i].id}
                      variant="outlined"
                      size="small"
                      fullWidth
                      color="error"
                    >
                      Delete
                    </Button>
                  </PopConfirm>
                ) : (
                  <Button
                    id={res.data[i].id}
                    variant="outlined"
                    size="small"
                    color="error"
                    disabled
                  >
                    Delete
                  </Button>
                )}
              </div>
            ),
          });
        }
      }

      data.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });

      setHistoryData(data);
      // setHistoryLoading(false);
    });
  }, [onDelete, navigate, props]);

  return (
    <>
      <div className="page-content" style={{
        margin: '0px',
        display: 'flex',
        justifyContent: 'center'
      }}>
        {historyData.length > 0 ? (
          <div className="ui-table">
            <div className="ui-table-filter">{/* apply filter here*/}</div>
            {/* <Table pagination={{ position: ['bottomCenter'], defaultPageSize: 4 }} tableLayout='auto' size='middle' loading={historyLoading} columns={historyColumns} dataSource={historyData} /> */}
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ height: 600 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {historyColumns.map((col, idx) => {
                        return (
                          <TableCell
                            key={idx}
                            align={col.align ? col.align : "left"}
                          >
                            {col.title}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historyData
                      .slice(
                        historyPage * historyRPP,
                        historyPage * historyRPP + historyRPP
                      )
                      .map((row) => {
                        return (
                          <TableRow hover tabIndex={-1} key={row.key}>
                            {historyColumns.map((col, idx) => {
                              return (
                                <TableCell
                                  key={idx}
                                  align={col.align ? col.align : "left"}
                                >
                                  {row[col.key]}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5]}
                component="div"
                count={historyData.length}
                rowsPerPage={5}
                page={historyPage}
                onPageChange={handleChangeHistoryPage}
              />
            </Paper>
          </div>
        ) : (
          <NoData fold={false} />
        )}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(History);
